import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  OrderByDirection,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformOnboardingEmailChangeEligibility } from './onboarding-email-change.transformers';
import type { OnboardingEmailChangeCollection } from './onboarding-email-change.types';

const ONBOARDING_EMAIL_CHANGE_TYPE = 'onboardingEmailChange' as const;

export function onboardingEmailChangeReducer(
  state: CollectionStateSlice<OnboardingEmailChangeCollection> = {},
  action: CollectionActions<OnboardingEmailChangeCollection>,
): CollectionStateSlice<OnboardingEmailChangeCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === ONBOARDING_EMAIL_CHANGE_TYPE) {
        const { result, ref, order } = action.payload;

        return mergeDocuments<OnboardingEmailChangeCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformOnboardingEmailChangeEligibility,
          ),
          order,
          ref,
        );
      }

      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === ONBOARDING_EMAIL_CHANGE_TYPE) {
        const { ref } = action.payload;

        // When email change is successful, update the eligibility to false
        const eligibilityDocument = {
          id: `onboarding-email-change-eligibility`,
          email: '',
          isEligible: false,
        };

        return mergeDocuments<OnboardingEmailChangeCollection>(
          state,
          transformIntoDocuments([eligibilityDocument], doc => doc),
          [{ field: 'id', direction: OrderByDirection.DESC }],
          ref,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
